/* @flow strict */

import * as React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import '../checkout.scss';
import './download.scss';
import '../ticket/ticket.scss';

type PropsType = {
  event: {
    id: string,
    name: string,
    location: string,
    begin_time_utc: dateFormat,
    end_time_utc: dateFormat
  }
};
const OtherEvent = (props: PropsType): React.Element<'div'> => {
  const { event } = props;

  return (
    <div className={'sparxo-checkout-Ticket_wrapper'}>
      <div className={'sparxo-checkout-Ticket_wrapperBefore'} />
      <div className={'sparxo-checkout-Ticket_ticket'}>
        <div className={'sparxo-checkout-download_event'}>
          <div className={'sparxo-checkout-download_event_info'}>
            <div className={'sparxo-checkout-download_event_date_wrapper'}>
              <div className={'sparxo-checkout-download_event_month'}>
                {event ? moment(event.begin_time_utc).format('MMM') : ''}
              </div>
              <div className={'sparxo-checkout-download_event_date'}>
                {event ? moment(event.begin_time_utc).format('DD') : ''}
              </div>
            </div>
            <div className={'sparxo-checkout-download_event_desc'}>
              <div className={'sparxo-checkout-download_event_name'}>{event.name}</div>
              <div className={'sparxo-checkout-download_event_adress'}>{event.location}</div>
              <div className="sparxo-checkout-event_event_time">
                {event ? moment(event.begin_time_utc).format('MMMM DD h:mm a') : ''}
                <span> - </span>
                {event ? moment(event.end_time_utc).format('MMMM DD h:mm a') : ''}
              </div>
            </div>
          </div>
          <Link
            to={{ pathname: `/events/${event.id}` }}
            className={'sparxo-checkout_secondaryBtn sparxo-checkout-download_event_ticket_btn'}
          >
            Tickets
          </Link>

        </div>
      </div>
      <div className={'sparxo-checkout-Ticket_wrapperAfter'} />
    </div>
  );
};

export default OtherEvent;
